// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__KmZ06","icon":"CustomButton_icon__agWCV","text":"CustomButton_text__T1FDS"};